/*
 * Canivoa – Startseite: waagerechte Schiene der Kategoriekreise.
 *
 * Die Pfeile erscheinen nur, wenn mehr Kacheln da sind als hineinpassen, und
 * schalten sich am jeweiligen Ende ab. Kommt eine Kategorie dazu, wird
 * gescrollt statt umgebrochen – ohne dass jemand etwas einstellen muss.
 *
 * Eigene Animation statt scroll-behavior:smooth, damit Dauer und Verlauf
 * festliegen. Wichtig ist der Kurzschluss in gleiten(): In einem unsichtbaren
 * Tab laeuft requestAnimationFrame nicht – ohne ihn bliebe die Schiene dort
 * stehen. Dasselbe gilt fuer prefers-reduced-motion, dort springt sie.
 */
(function () {
  function schiene(huelle) {
    var spur = huelle.querySelector('.canivoa-streifen');
    var zurueck = huelle.querySelector('.canivoa-streifen__pfeil--zurueck');
    var vor = huelle.querySelector('.canivoa-streifen__pfeil--vor');
    if (!spur || !zurueck || !vor || huelle.dataset.canivoaSchiene) return;
    huelle.dataset.canivoaSchiene = '1';
    var lauf = 0;

    function schrittweite() {
      var k = spur.querySelector('.canivoa-streifen__kachel');
      return k ? Math.round(k.getBoundingClientRect().width) + 20 : 200;
    }

    function pruefen() {
      var noetig = spur.scrollWidth > spur.clientWidth + 1;
      zurueck.hidden = !noetig;
      vor.hidden = !noetig;
      if (!noetig) return;
      // Erst einblenden, dann messen: an einem versteckten Knopf ist
      // offsetHeight 0 und die Pfeile saessen 19 px zu tief.
      var kreis = spur.querySelector('.canivoa-streifen__kreis');
      if (kreis) {
        var h = kreis.getBoundingClientRect().height;
        if (h) {
          huelle.style.setProperty('--canivoa-pfeil-oben',
            Math.round(h / 2 - zurueck.offsetHeight / 2) + 'px');
        }
      }
      zurueck.disabled = spur.scrollLeft <= 1;
      vor.disabled = spur.scrollLeft >= spur.scrollWidth - spur.clientWidth - 1;
    }

    function gleiten(ziel) {
      var max = spur.scrollWidth - spur.clientWidth;
      ziel = Math.max(0, Math.min(max, ziel));
      var start = spur.scrollLeft;
      var weg = ziel - start;
      cancelAnimationFrame(lauf);
      if (document.hidden || Math.abs(weg) < 2 ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        spur.scrollLeft = ziel;
        pruefen();
        return;
      }
      var t0 = performance.now();
      lauf = requestAnimationFrame(function schritt(t) {
        var p = Math.min(1, (t - t0) / 380);
        var w = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        spur.scrollLeft = start + weg * w;
        if (p < 1) { lauf = requestAnimationFrame(schritt); } else { pruefen(); }
      });
    }

    zurueck.addEventListener('click', function () { gleiten(spur.scrollLeft - schrittweite()); });
    vor.addEventListener('click', function () { gleiten(spur.scrollLeft + schrittweite()); });
    spur.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(pruefen); }
    spur.querySelectorAll('img').forEach(function (b) {
      if (!b.complete) { b.addEventListener('load', pruefen, { once: true }); }
    });
    pruefen();
  }

  function start() {
    document.querySelectorAll('.canivoa-streifen__huelle').forEach(schiene);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Im Theme-Editor wird eine Section neu gezeichnet, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', start);
})();
